module.exports = __webpack_public_path__ + "img/new3-img1.1ed69aff.jpg";